/**
 * 打印：读取 localStorage「adminThermalSettings」
 * （printEndpoint、categoryToPrinter、categoryPrintMode、ticketStyle），并与「restaurantMenu」内嵌的
 * ticketStyle（由后台保存进 menu.json、顾客端同步）合并——后者作默认，前者覆盖；避免 iPad 未进过后台时
 * 小票字号一直落在默认值而与电脑不一致。
 */
(function (global) {
  'use strict';

  function defaultThermalPrintServiceRoot() {
    try {
      var RC = global.RestaurantConstants;
      if (RC && RC.OS_LAN_IPV4) {
        var p = RC.DEFAULT_HTTP_PORT != null ? Number(RC.DEFAULT_HTTP_PORT) : 3000;
        return 'http://' + String(RC.OS_LAN_IPV4).trim() + ':' + p;
      }
    } catch (_) {}
    return 'http://192.168.100.112:3000';
  }

  const THERMAL_STORAGE_KEY = 'adminThermalSettings';
  const SYSTEM_SETTINGS_KEY_PRINT = 'restaurantSystemSettings';
  const UI_LANG_KEY = 'restaurantUiLang';
  const UI_LANG_ALLOWED_PRINT_PKG = ['de', 'en', 'es', 'it', 'fr', 'zh', 'ja', 'tr'];

  const MENU_KEY_THERMAL = 'restaurantMenu';

  function loadRestaurantMenuForThermal() {
    try {
      const raw = global.localStorage.getItem(MENU_KEY_THERMAL);
      if (!raw) return null;
      const o = JSON.parse(raw);
      if (!o || !Array.isArray(o.dishes)) return null;
      return o;
    } catch {
      return null;
    }
  }

  function dishNameFromStoredMenu(dish, lang) {
    if (!dish) return '';
    if (lang === 'zh') {
      if (dish.t && dish.t.zh && dish.t.zh.n) return String(dish.t.zh.n).trim();
      if (dish.name) return String(dish.name).trim();
      if (dish.t && dish.t.en && dish.t.en.n) return String(dish.t.en.n).trim();
      return '';
    }
    const tr = dish.t && dish.t[lang];
    if (tr && tr.n) return String(tr.n).trim();
    if (dish.name) return String(dish.name).trim();
    return '';
  }

  /** 为 POST /print 补充 nameDe、nameZh，与 server thermalDishDisplayText 一致 */
  function enrichThermalOrderItems(items) {
    if (!items || !items.length) return [];
    const menu = loadRestaurantMenuForThermal();
    if (!menu) return items.map((it) => ({ ...it }));
    return items.map((it) => {
      const copy = { ...it };
      const id = it && (it.dishId != null ? it.dishId : it.id);
      if (id == null) return copy;
      const d = menu.dishes.find((x) => String(x.id) === String(id));
      if (!d) return copy;
      const hasDe = copy.nameDe != null && String(copy.nameDe).trim() !== '';
      const hasZh = copy.nameZh != null && String(copy.nameZh).trim() !== '';
      if (!hasDe) {
        const s = dishNameFromStoredMenu(d, 'de');
        if (s) copy.nameDe = s;
      }
      if (!hasZh) {
        const s = dishNameFromStoredMenu(d, 'zh');
        if (s) copy.nameZh = s;
      }
      return copy;
    });
  }

  function readTicketUiLangForPrint() {
    try {
      const RCL = global.RestaurantConfigLib;
      if (RCL && typeof RCL.getUiLang === 'function') {
        const code = RCL.getUiLang();
        if (typeof code === 'string' && UI_LANG_ALLOWED_PRINT_PKG.includes(code)) return code;
      }
      const raw = global.localStorage.getItem(UI_LANG_KEY);
      if (raw === null || raw === '') return 'de';
      let v;
      try {
        v = JSON.parse(raw);
      } catch {
        v = raw;
      }
      if (typeof v === 'string' && UI_LANG_ALLOWED_PRINT_PKG.includes(v)) return v;
    } catch {
      /* ignore */
    }
    return 'de';
  }

  function loadThermalRaw() {
    try {
      const raw = global.localStorage.getItem(THERMAL_STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  /** 与点餐页同源部署时，用当前页面 origin 作为打印服务根（避免未进过后台时误用 192.168.1.100） */
  function inferPrintBaseFromLocation() {
    try {
      const loc = global.location;
      if (!loc || !/^https?:$/i.test(String(loc.protocol || ''))) return '';
      return String(loc.origin || '').replace(/\/$/, '');
    } catch {
      return '';
    }
  }

  /**
   * 后台常保存 127.0.0.1；iPad 用局域网打开点餐页时，需把主机换成当前页 hostname，否则会打到平板本机。
   */
  function coerceLoopbackEndpointToPageHost(savedBase, pageOrigin) {
    if (!savedBase || !pageOrigin) return savedBase;
    try {
      const u = new URL(/^https?:\/\//i.test(savedBase) ? savedBase : 'http://' + String(savedBase).replace(/^\/+/, ''));
      const loop = u.hostname === 'localhost' || u.hostname === '127.0.0.1';
      if (!loop) return savedBase.replace(/\/$/, '');
      const p = new URL(pageOrigin);
      const pHost = p.hostname;
      if (!pHost || pHost === 'localhost' || pHost === '127.0.0.1') return savedBase.replace(/\/$/, '');
      u.hostname = pHost;
      if (!u.port && p.port) u.port = p.port;
      return u.origin.replace(/\/$/, '');
    } catch {
      return String(savedBase || '').replace(/\/$/, '');
    }
  }

  /** 与 server lib/ticket-style.js 一致（浏览器不可 require） */
  var TICKET_FONT_SIZES = [8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72];
  var LEGACY_TICKET_FONT = { sm: 14, md: 18, lg: 22 };

  function snapTicketFontSizeClient(n, def) {
    if (!Number.isFinite(n)) return def;
    var best = TICKET_FONT_SIZES[0];
    var diff = Math.abs(n - best);
    for (var i = 0; i < TICKET_FONT_SIZES.length; i++) {
      var a = TICKET_FONT_SIZES[i];
      var d = Math.abs(n - a);
      if (d < diff) {
        diff = d;
        best = a;
      }
    }
    return best;
  }

  function pickTicketFontSizeClient(v, def) {
    if (v == null || v === '') return def;
    if (typeof v === 'string' && LEGACY_TICKET_FONT[v] != null) return LEGACY_TICKET_FONT[v];
    var n = parseInt(v, 10);
    if (!Number.isFinite(n)) return def;
    return snapTicketFontSizeClient(n, def);
  }

  function normalizeSingleSlipDishTextClient(v) {
    if (v === 'de' || v === 'zh') return v;
    return 'both';
  }

  function normalizeTicketStyleForClient(raw) {
    const d = raw && typeof raw === 'object' ? raw : {};
    const layout = d.itemLayout === 'vertical' ? 'vertical' : 'horizontal';
    const tableFontSize = pickTicketFontSizeClient(d.tableFontSize, 18);
    return {
      itemLayout: layout,
      tableFontSize,
      guestFontSize: pickTicketFontSizeClient(d.guestFontSize, tableFontSize),
      tableBold: d.tableBold !== false,
      itemFontSize: pickTicketFontSizeClient(d.itemFontSize, 16),
      itemBold: d.itemBold === true,
      showDate: d.showDate !== false,
      showTime: d.showTime !== false,
      footerFontSize: pickTicketFontSizeClient(d.footerFontSize, 14),
      singleSlipDishText: normalizeSingleSlipDishTextClient(d.singleSlipDishText),
    };
  }

  function normalizeKitchenCategoryPrintModeForMerge(raw) {
    const out = {};
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return out;
    Object.keys(raw).forEach((k) => {
      const v = raw[k];
      if (v === 'single' || v === 'summary') out[k] = v;
    });
    return out;
  }

  /** 系统设定 kitchenCategoryPrintMode 覆盖 thermal 同键（与 Lite liteOrderKitchenMetaForPost 一致） */
  function mergeCategoryPrintModesForKitchen(thermalCpm, settingsCpm) {
    return {
      ...normalizeKitchenCategoryPrintModeForMerge(thermalCpm),
      ...normalizeKitchenCategoryPrintModeForMerge(settingsCpm),
    };
  }

  function readKitchenCategoryPrintModeFromSystemSettings() {
    try {
      const RCL = global.RestaurantConfigLib;
      if (RCL && typeof RCL.getSystemSettings === 'function') {
        const s = RCL.getSystemSettings();
        if (s && s.kitchenCategoryPrintMode && typeof s.kitchenCategoryPrintMode === 'object' && !Array.isArray(s.kitchenCategoryPrintMode)) {
          return normalizeKitchenCategoryPrintModeForMerge(s.kitchenCategoryPrintMode);
        }
      }
      const raw = global.localStorage.getItem(SYSTEM_SETTINGS_KEY_PRINT);
      if (!raw) return {};
      const o = JSON.parse(raw);
      return normalizeKitchenCategoryPrintModeForMerge(o && o.kitchenCategoryPrintMode);
    } catch {
      return {};
    }
  }

  function normalizeThermal(o) {
    const base = o && typeof o === 'object' ? o : {};
    const pageBase = inferPrintBaseFromLocation();
    let ep =
      base.printEndpoint != null && String(base.printEndpoint).trim()
        ? String(base.printEndpoint).trim().replace(/\/$/, '')
        : '';
    if (ep) ep = coerceLoopbackEndpointToPageHost(ep, pageBase);
    else ep = pageBase || defaultThermalPrintServiceRoot();
    const mode = base.printMode === 'single' ? 'single' : 'summary';
    const categoryToPrinter =
      base.categoryToPrinter && typeof base.categoryToPrinter === 'object' ? { ...base.categoryToPrinter } : {};
    if (categoryToPrinter.default == null || String(categoryToPrinter.default).trim() === '') {
      categoryToPrinter.default = 'default';
    }
    const categoryPrintMode = {};
    if (base.categoryPrintMode && typeof base.categoryPrintMode === 'object' && !Array.isArray(base.categoryPrintMode)) {
      Object.keys(base.categoryPrintMode).forEach((k) => {
        const v = base.categoryPrintMode[k];
        if (v === 'single' || v === 'summary') categoryPrintMode[k] = v;
      });
    }
    const ticketStyle = normalizeTicketStyleForClient(base.ticketStyle);
    return {
      printEndpoint: ep,
      printMode: mode,
      categoryToPrinter: categoryToPrinter,
      categoryPrintMode,
      ticketStyle,
    };
  }

  function effectivePrintModeForCategory(catId, thermal) {
    const cpm = thermal.categoryPrintMode && typeof thermal.categoryPrintMode === 'object' ? thermal.categoryPrintMode : {};
    const k = catId != null ? String(catId) : '';
    if (k && (cpm[k] === 'single' || cpm[k] === 'summary')) return cpm[k];
    if (cpm.default === 'single' || cpm.default === 'summary') return cpm.default;
    if (thermal.printMode === 'single' || thermal.printMode === 'summary') return thermal.printMode;
    return 'summary';
  }

  function getPrintConfig() {
    const raw = loadThermalRaw();
    const base = raw && typeof raw === 'object' ? raw : {};
    const menu = loadRestaurantMenuForThermal();
    const menuTs =
      menu && menu.ticketStyle && typeof menu.ticketStyle === 'object' && !Array.isArray(menu.ticketStyle)
        ? menu.ticketStyle
        : {};
    const thermalTs = base.ticketStyle && typeof base.ticketStyle === 'object' ? base.ticketStyle : {};
    return normalizeThermal({ ...base, ticketStyle: { ...menuTs, ...thermalTs } });
  }

  /** 无 AbortController 的旧环境用 Promise.race 限制 fetch 挂死时间 */
  function fetchWithTimeout(url, init, timeoutMs) {
    const ms = timeoutMs > 0 ? timeoutMs : 15000;
    return new Promise((resolve, reject) => {
      let settled = false;
      const t = setTimeout(() => {
        if (settled) return;
        settled = true;
        reject(new Error('Print timeout'));
      }, ms);
      global
        .fetch(url, init)
        .then((res) => {
          if (settled) return;
          settled = true;
          clearTimeout(t);
          resolve(res);
        })
        .catch((err) => {
          if (settled) return;
          settled = true;
          clearTimeout(t);
          reject(err);
        });
    });
  }

  /** 得到 POST /print 的完整 URL（含 /print） */
  function resolvePrintUrl(printEndpoint) {
    let u = String(printEndpoint || '').trim().replace(/\/$/, '');
    if (!u) u = inferPrintBaseFromLocation() || defaultThermalPrintServiceRoot();
    if (!/\/print$/i.test(u)) u = u + '/print';
    return u;
  }

  /**
   * 按菜品 category 映射到打印机逻辑名，再按逻辑名合并为多条「打印任务」，逐条 POST。
   * @param {object} order
   * @param {string|number} [order.tableNo]
   * @param {string|number} [order.table]
   * @param {Array<{name?:string,quantity?:number,q?:number,category?:string}>} order.items
   * @param {string} [order.at] ISO 时间
   * @returns {Promise<{ ok: boolean, results: Array<{ printerLogical: string, ok: boolean, status: number, data: object|string }> }>}
   */
  async function sendOrderToServer(order) {
    const thermal = getPrintConfig();
    const cpmMerged = mergeCategoryPrintModesForKitchen(
      thermal.categoryPrintMode && typeof thermal.categoryPrintMode === 'object' ? thermal.categoryPrintMode : {},
      readKitchenCategoryPrintModeFromSystemSettings()
    );
    const thermalMerged = { ...thermal, categoryPrintMode: cpmMerged };
    const printUrl = resolvePrintUrl(thermalMerged.printEndpoint);
    const printerCfg = thermalMerged.categoryToPrinter;

    const tableNo = order && (order.tableNo != null ? order.tableNo : order.table);
    const items = enrichThermalOrderItems(order && Array.isArray(order.items) ? order.items : []);
    const at = (order && order.at) || new Date().toISOString();
    const guestName =
      order && order.guestName != null && String(order.guestName).trim() !== ''
        ? String(order.guestName).trim().slice(0, 64)
        : '';

    if (tableNo == null || String(tableNo).trim() === '') {
      return {
        ok: false,
        results: [{ printerLogical: '', ok: false, status: 0, data: { error: '缺少桌号 tableNo 或 table' } }],
      };
    }
    if (items.length === 0) {
      return {
        ok: false,
        results: [{ printerLogical: '', ok: false, status: 0, data: { error: 'items 为空' } }],
      };
    }

    const CS = global.RestaurantCartService;
    const entries =
      CS && typeof CS.groupThermalOrderItems === 'function'
        ? CS.groupThermalOrderItems(items, thermalMerged)
        : (() => {
            const byKey = {};
            items.forEach((it) => {
              const cat = it && it.category != null ? String(it.category) : '';
              let logical = null;
              if (it && it.thermalPrinter != null && String(it.thermalPrinter).trim() !== '') {
                logical = String(it.thermalPrinter).trim();
              } else if (cat && printerCfg[cat] != null && String(printerCfg[cat]).trim() !== '') {
                logical = String(printerCfg[cat]).trim();
              }
              if (!logical && printerCfg._uncat != null && String(printerCfg._uncat).trim() !== '') {
                logical = String(printerCfg._uncat).trim();
              }
              if (!logical && printerCfg.default != null && String(printerCfg.default).trim() !== '') {
                logical = String(printerCfg.default).trim();
              }
              if (!logical) logical = 'default';
              const mode = effectivePrintModeForCategory(cat, thermalMerged);
              const key = logical + '\0' + mode;
              if (!byKey[key]) byKey[key] = { printerLogical: logical, printMode: mode, items: [] };
              byKey[key].items.push(it);
            });
            return Object.values(byKey);
          })();
    const results = await Promise.all(
      entries.map(async ({ printerLogical, printMode: groupMode, items: subset }) => {
        const or = order && order.orderRound != null ? parseInt(String(order.orderRound), 10) : NaN;
        const body = {
          tableNo,
          items: subset,
          printMode: groupMode,
          printerConfig: printerCfg,
          categoryPrintMode: cpmMerged,
          ticketStyle: thermalMerged.ticketStyle,
          ticketUiLang: readTicketUiLangForPrint(),
          at,
          ...(guestName ? { guestName } : {}),
          ...(Number.isFinite(or) && or > 0 ? { orderRound: or } : {}),
        };
        try {
          const res = await fetchWithTimeout(
            printUrl,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body),
            },
            15000
          );
          const text = await res.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch {
            data = text;
          }
          return { printerLogical, ok: res.ok, status: res.status, data };
        } catch (e) {
          return {
            printerLogical,
            ok: false,
            status: 0,
            data: { error: String(e.message || e) },
          };
        }
      })
    );

    return { ok: results.length > 0 && results.every((r) => r.ok), results };
  }

  global.RestaurantPrintLib = {
    THERMAL_STORAGE_KEY,
    getPrintConfig,
    loadThermalRaw,
    normalizeThermal,
    normalizeTicketStyleForClient,
    resolvePrintUrl,
    effectivePrintModeForCategory,
    mergeCategoryPrintModesForKitchen,
    readKitchenCategoryPrintModeFromSystemSettings,
    sendOrderToServer,
  };

  if (global.OS && typeof global.OS.registerModule === 'function') {
    try { global.OS.registerModule('print', global.RestaurantPrintLib); } catch (_) {}
  }
})(typeof window !== 'undefined' ? window : globalThis);
